var AdaptiveImage = require("../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/ic-home.37d92dd4.png","uri@2x": __webpack_public_path__ + "static/media/ic-home.16677549.png","uri@3x": __webpack_public_path__ + "static/media/ic-home.934638d0.png",
    width: 24,
    height: 24
});